import { csx } from '@vtex/admin-ui'

export const styles = {
  range: csx({
    display: 'flex',
    alignItems: 'baseline',
    gap: '$space-4',
    '>div': {
      flex: 1,
    },
  }),
}
